
import { useState } from "react";
import { useAuth } from "../../provider";
import * as c from "../../constants";
import axios from "axios";
import { useTranslation } from "../../language";
import { Button, CircularProgress, InputAdornment, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";

import { Formik, Form } from "formik";
import * as Yup from "yup";

import TextInput from "../../components/Forms/TextInput";


const buildValidation = (t) => Yup.object({
  email: Yup.string()
    .email(t("val_email_valid"))
    .required(t("val_email_req")),
});


const ForgotForm = () => {

  const { t } = useTranslation();
  const theme = useTheme();

  const url_forgot_pw = `${c.API_URL}/api/password_reset/`;

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);


  const handleSubmit = async (values, { resetForm }) => {
    setError("");
    setSuccess(false);

    try {
      await axios.post(url_forgot_pw, values, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      setSuccess(true);
      resetForm();
    } catch (err) {
      if (err.response?.data) {
        setError(
          typeof err.response.data === "string"
            ? err.response.data
            : err.response.data?.detail || t("val_server_error")
        );
      } else {
        setError(t("val_server_error"));
      }
    }
  };


  return (

    <Formik
      initialValues={{ email: "" }}
      validationSchema={buildValidation(t)}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>

          <TextInput
            label="Email"
            name="email"
            type="email"
            placeholder="email"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MailIcon />
                </InputAdornment>
              ),
            }}
          />

          <Button
            variant="text"
            type="submit"
            disabled={isSubmitting}
            sx={{
              minWidth: { xs: 80, sm: 90, md: 100 },
              p: '10px',
              color: theme.palette.mode === 'light' ? 'common.black' : 'grey.C100',
              fontWeight: 600,
              transition: 'transform 0.2s ease',
              '&:hover': {
                p: '10px 12px',
                color: 'common.white',
                bgcolor: 'greydark.C900',
                borderRadius: 5,
                transform: 'scale(1.08)',
              },
            }}
          >
            {isSubmitting ? <CircularProgress size={18} color="inherit" /> : t("reset_3")}
          </Button>

          {error && (
            <Typography variant="body2" align="center" color="error" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}

          {success && (
            <Typography variant="body2" align="center" color="success.main" sx={{ mt: 2 }}>
              {t("reset_8")}
            </Typography>
          )}

        </Form>
      )}
    </Formik>

  );
};

export default ForgotForm;
